import { Component, OnDestroy, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { map, tap, switchMap, skipWhile, filter, takeUntil, skip } from 'rxjs/operators';
import { PageName, TaxonomyPageName, CONSTANTS, Chip } from '@app/constants';
import { TaxonomyTermSchools, DefaultIndexDoc } from '@app/graphql';
import { fadeInAnimation } from '@app/animations';
import { DataService, PagesService, FacetsService } from '@app/data';

@Component({
  selector: 'app-school',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './school.component.html',
  styleUrls: ['./school.component.less'],
  animations: [fadeInAnimation]
})
export class SchoolComponent implements OnDestroy {

  public queryParams$ = this.pages.queryParams$;
  public route: any = this.pages.getCurrentPage();
  public pageName: string = this.route.pageName;
  public class: string = this.route.secton;
  public currentTaxonomyPage$ = this.data.currentTaxonomyPage$;
  private unsubscribe$: Subject<void> = new Subject();
  public hasContent$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public filters$ = new BehaviorSubject<any[]>([]);
  public route$ = this.data.route$;

  public facets$: Observable<any> = this.facets.facets$;

  constructor(
    private data: DataService,
    private pages: PagesService,
    private facets: FacetsService
  ) {
    
    this.facets$.pipe(takeUntil(this.unsubscribe$)).subscribe((res: any) => {
      console.log('**** SchoolComponent facets$ res ', res);
      if (res) {
        this.filters$.next(res.get('sekce'));
      }
    });
  }

  ngOnDestroy(): void {
    //console.log('SchoolComponent ngOnDestroy');

    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  get taxonomyPageName(): string {

    return this.data.getTaxonomyPageName();
  }

  private pageUrl = (): string => this.pages.getCurrentPage().url; 
  public getClass = (): string => this.data.getClass();

}
